import { apiFetcher, Result } from '@gjensidige/service-async';
import { GjeApiError } from '@gjensidige/service-async/lib/types/errors/GjeApiError';
import { GjeRequestInitJson } from '@gjensidige/service-async/lib/types/types';

import { API_ENDPOINTS, APP_CONSTANTS } from '../constants';
import { InsuranceHelper } from '../../utils/InsuranceHelper';
export const fetchInsuranceOffers = async (
  createOfferPaylod: any
): Promise<Result<any, GjeApiError>> => {
  const request: GjeRequestInitJson = {
    headers: {
      Applikasjon: APP_CONSTANTS.application
    },
    body: {
      ...createOfferPaylod
    }
  };

  const response: any = await apiFetcher.postJson(
    API_ENDPOINTS.createOfferURL,
    request
  );
  return response;
};

export const checkCustomerEligibility = async (
  checkEligibilityPayload: GjeRequestInitJson
) => {
  let eligibilityInfo = {
    customerName: '',
    eligible: false,
    errorMessage: '',
    errorTitle: '',
    errorStatus: 0
  };
  const request: GjeRequestInitJson = checkEligibilityPayload;

  const response: any = await apiFetcher.postJson(
    API_ENDPOINTS.getEligibilityURL(),
    request
  );
  if (response.isOk()) {
    if (response.value && !InsuranceHelper.isEmptyObject(response.value)) {
      eligibilityInfo = {
        customerName: response.value.customerName,
        eligible: !response.value.calculationStatus.error,
        errorMessage: response?.value?.calculationStatus?.message
          ? response.value.calculationStatus.message
          : '',
        errorTitle: response?.value?.calculationStatus?.title
          ? response.value.calculationStatus.title
          : '',
        errorStatus: response?.value?.calculationStatus?.statusCode || 0
      };
    }
  }
  return eligibilityInfo;
};

export const checkLoginStatus = async () => {
  let isLoggedIn = false;
  const response: any = await apiFetcher.getJson(
    API_ENDPOINTS.getLoggedInStatusUrl
  );

  if (response.isOk()) {
    if (response.value && !InsuranceHelper.isEmptyObject(response.value)) {
      const responseObj = response.value;
      isLoggedIn = parseInt(responseObj.value) > 0;
    }
  }
  return isLoggedIn;
};
